import { classes } from "../client";

export const addClasses = (params) => {
  const user = {
    flag: "uploadClasses",
    parameters: {
      classesData: params,
    },
  };
  return classes.post("/staff/classes/upload", user);
};

export const updateClasses = (params) => {
  const user = {
    flag: "updateClasses",
    parameters: {
      classes: params,
    },
  };
  return classes.post("/staff/classes/upload", user);
};

export const getClasses = (payload) => {
  const { signal, ...params } = payload;
  const user = {
    flag: "getClasses",
    parameters: { classes: params },
  };
  console.log("signal", signal);
  return classes.post("/staff/get/classes", user, { signal: signal });
};

export const deleteClasses = (params) => {
  const user = {
    flag: "deleteClasses",
    parameters: { classes: params },
  };
  return classes.delete("/staff/delete/classes", { data: user });
};
